import { render, staticRenderFns } from "./ButtonRemoveTable.vue?vue&type=template&id=181a83e3&scoped=true"
import script from "./ButtonRemoveTable.vue?vue&type=script&lang=js"
export * from "./ButtonRemoveTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a83e3",
  null
  
)

export default component.exports